export default {
  processURL(url){
    if (!url.startsWith('http')){
      return "https://" + url
    }
    return url
  },
  processWhatsapp(num){
    return "https://wa.me/55" + num.match(/\d/g).join('');
  },
}
